'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./production/server.react-client.js');
} else {
  module.exports = require('./development/server.react-client.js');
}
